<template>
  <div class="content-box">
    <HconTitle subTitle="1:1 문의" subDescription="Hcon 사이트 이용 및 모바일 쿠폰 서비스 관련 문의를 남겨주시면 신속하게 답변드리겠습니다." />      
    <div class="sub-wrapper block">
      <div class="border-title title">
        <p class="title flex al-c">{{ pageTitle }}<span class="ml12 text-gray02 fs16 font-normal bar">이용 중 불편하신 사항이나 문의 내용을 남겨주시면 확인 후 빠르게 답변드리겠습니다.</span></p>
        <div class="button-box">
          <div class="">
            <NuxtLink to="/pc/inquiry/list" class="btn btn-outline">나의 문의 목록</NuxtLink>
          </div>
        </div>
      </div>
      <div class="table-box qna">
        <table class="tbl-type tbl-type-row">
          <caption></caption>
          <colgroup>
            <col style="width:15%" />
            <col style="width:auto" />
          </colgroup>
          <tbody>
            <tr>
              <th scope="row" class="left">문의 유형<span class="required">*</span></th>
              <td class="left">
                <div class="form-box">
                  <div class="form-group row" :class="{'error': isTypeError}">
                    <HconDropDown type="dropdownBox" :dropdownOptions="inqTypeOptionList" selectBoxTitleClass="wd186 md counter" v-model="inquiryForm.inqType" />
                  </div>
                  <p v-if="isTypeError" class="helper-text error p0">문의 유형을 선택해주세요.</p>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="left">구매 및 거래내역</th>
              <td class="left">
                <div class="flex al-c">
                  <div class="button-box gap8 shrink0 mr20">
                    <button type="button" class="btn btn-outline" @click="goToOrderHistoryPopup">구매내역조회</button>
                    <button type="button" class="btn btn-outline" @click="goToHcashHistoryPopup">H캐시 거래내역조회</button>
                  </div>
                  <ul class="flex flex-wrap">
                    <li v-if="inquiryForm.buyOrderNum" class="tag-li order">
                    <HconComPCTag :textTag="true" customTagClass="order" @delete="inquiryForm.buyOrderNum = ''">
                      <span>구매 주문번호 : {{ inquiryForm.buyOrderNum }}</span>
                    </HconComPCTag>
                    </li>
                    <li v-if="inquiryForm.hmoneyTransNum" class="tag-li order">
                    <HconComPCTag :textTag="true" customTagClass="order" @delete="inquiryForm.hmoneyTransNum = ''">
                      <span>H캐시 거래번호 : {{ inquiryForm.hmoneyTransNum }}</span>
                    </HconComPCTag>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="left">문의 제목<span class="required">*</span></th>
              <td class="left">
                <div class="form-box">
                  <div class="form-group row" :class="{'error': isTitleError}">
                    <HconInput type="message" label="문의제목" v-model="inquiryForm.title" :hide-label="true" inputClass="md" :max="100" placeholder="내용을 입력하세요." required />
                  </div>
                  <p v-if="isTitleError" class="helper-text error p0">문의 제목을 입력해주세요.</p>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="left">문의 내용<span class="required">*</span></th>
              <td class="left">
                <div class="form-box">
                  <div class="form-group row" :class="{'error': isTextError}">
                      <HconTextarea v-model="inquiryForm.text" :bottomContent="false" :showRgtButton="false" textAreaBoxClass="hg176" charsBoxClass="top178" charListClass="col15"
                      placeholder="내용을 입력하세요." :maxChars="4000"/>
                  </div>
                  <p v-if="isTextError" class="helper-text error p0">문의 내용을 입력해주세요.</p>
                </div>
              </td>
            </tr>            
            <tr>
              <th scope="row" class="left">이메일<span class="required">*</span></th>
              <td class="left">
                <div class="flex al-c">
                  <div class="form-box">
                    <div class="form-group row" :class="{'error': isAlarmError}">
                      <HconInput type="text" label="이메일" v-model="inquiryForm.email" :hide-label="true" inpWrapClass="wd350" inputClass="md mr20" placeholder="회원정보에서 이메일을 입력하세요." readonly required />
                      <HconCheckBox type="default" label="답변완료 시 이메일로 알림 받기" :checked="inquiryForm.emailAlarmYn === 'Y'" @change="handleEmailAlarmYn" name="emailAlarmYn" labelClass="" :hide-label="false" required />
                    </div>
                    <!-- <p v-if="isAlarmError" class="helper-text error p0">이메일 또는 휴대폰번호를 알림받기 중 하나를 선택해주세요.</p> -->
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="left">휴대폰번호<span class="required">*</span></th>
              <td class="left">
                <div class="flex al-c gap20">
                  <div class="form-box">
                    <div class="form-group row" :class="{'error': isAlarmError}">
                      <HconInput type="text" v-model="inquiryForm.telNo" label="휴대폰번호" :hide-label="true" inpWrapClass="wd350" inputClass="md mr20" placeholder="회원정보에서 휴대폰번호를 입력하세요." readonly required />
                      <HconCheckBox type="default" label="답변완료 시 알림톡(문자)으로 알림 받기" :checked="inquiryForm.telNoAlarmYn === 'Y'" @change="handleTelNoAlarm" name="telNoAlarmYn" labelClass="" :hide-label="false" required />
                    </div>
                    <p v-if="isAlarmError" class="helper-text error p0">이메일 또는 알림톡(문자)으로 알림 받기 중 하나를 선택해주세요.</p>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="left">첨부파일</th>
              <td class="left">
                <div class="form-box">
                  <HconComMultiFileUpload
                      uiType="default"
                      token-provider="/api/v1/inquiry/upload-token"
                      :files-limit="3"
                      :select-validator="validateFile"
                      v-model="uploadFiles"
                    />
                    <div v-if="uploadFiles.length < 3" class="form-group row" >
                  </div>
                  <p class="helper-text p0">
                    * 첨부파일은 png, jpg, gif, pdf, 문서파일 등의 최대 3개, 총 10MB까지 업로드 가능합니다.
                  </p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- 버튼 s -->
      <div class="button-box col2 mt40">
        <button type="button" class="btn btn-outline lg" @click="showCancelAlert">취소</button>
        <button type="button" class="btn lg" @click="handleSubmit">{{ submitLabel }}</button>
      </div>
      <!-- 버튼 e -->
    </div>
  </div>
  <OrderHistoryPopup v-if="isOrderHistoryPopupOpen" @select="onSelectOrder" @close="isOrderHistoryPopupOpen = false"/>
  <HcashHistoryPopup v-if="isHcashHistoryPopupOpen" @select="onSelectHcash" @close="isHcashHistoryPopupOpen = false"/>
</template>
<script lang="ts" setup>
import HconTitle from '@/components/com/HconComPCTitle.vue'
import HconTextarea from '@/components/com/HconComPCTextarea.vue'
import HconCheckBox from '@/components/com/HconComPCCheckbox.vue'
import HconComPCTag from "@/components/com/HconComPCTag2.vue";
import HconInput from '@/components/com/HconComPCInputField.vue'
import HconDropDown from '@/components/com/HconComPCDropDown.vue';
import type { Inquiry } from '@/types/inquiry/backend-dto-types'
import HconComMultiFileUpload from '~/components/com/HconComMultiFileUpload.vue';
import OrderHistoryPopup from '~/pages/pc/inquiry/popup/OrderHistoryPopup.vue';
import HcashHistoryPopup from '~/pages/pc/inquiry/popup/HcashHistoryPopup.vue';
import { usePopup } from '@/composables/hconUsePopup';
import { ref } from 'vue';

// 문의유형 옵션 데이터
const inqTypeOptionList = [
    {key: '1001', value: '발송문의'}
  , {key: '1002', value: '결제문의'}
  , {key: '1003', value: '충전문의'}
  , {key: '1004', value: '취소/환불문의'}
  , {key: '1005', value: '서비스 이용문의'}
  , {key: '9999', value: '기타'}]

const route = useRoute();
const router = useRouter();
const isEdit = computed(() => route.query.mode === 'edit');
const pageTitle = computed(() => isEdit.value ? '1:1 문의 수정' : '1:1 문의 등록')
const submitLabel = computed(() => isEdit.value ? '수정' : '등록')
const inqDtl = ref<Inquiry>();
const inqId = computed(() => route.query.id);
const isOrderHistoryPopupOpen = ref(false) // 구매내역조회
const isHcashHistoryPopupOpen = ref(false) // H캐시 거래내역조회

// 1대1 문의 등록 타입
interface InquiryFormData {
  inqType: string,
  title: string,
  text: string,
  emailAlarmYn?: string,
  telNoAlarmYn?: string,
  email: string,
  telNo: string,
  buyOrderNum?: string,
  hmoneyTransNum?: string
  attachFileList?: CommonFile[]
}

const inquiryForm = ref<InquiryFormData>({
    inqType: '',
    title: '',
    text: '',
    email: '',
    telNo: '',
    emailAlarmYn: 'N',
    telNoAlarmYn: 'N',
    buyOrderNum: '',
    hmoneyTransNum: ''
  });

// 첨부파일
const uploadFiles = ref<CommonFile[]>([]);
const maxFileSize = 1024 * 1024 * 10; // 10MB

// 파일업로드 체크
const validateFile = (selectedFiles: File[]) => {
  let totalSize = uploadFiles.value.reduce((sum, file) => sum + file.size, 0);
  for (const file of selectedFiles) {
    if (totalSize + file.size > maxFileSize) {
      return `첨부파일은 총 10MB까지 업로드 가능합니다.`;
    }
  }
  return null;
};

// 입력오류
let isTypeError = ref(false);
let isTitleError = ref(false);
let isTextError = ref(false);
let isAlarmError = ref(false);
const isSubmitted = ref(false);

// 팝업
const {
  showAlert,
  showConfirm
} = usePopup()
const fetchBuilder  = useHconFetchBuilder();

// 취소하기 팝업
const showCancelAlert = () => {
  showConfirm({
    title: isEdit.value ? '문의 수정 취소' : '문의 등록 취소',
    message: '작성 중인 내용은 저장되지 않습니다.<br />정말 취소하시겠습니까?',
    confirmText: '확인',
    cancelText: '취소',
    onConfirm: () => {
      isEdit.value ? router.push(`/pc/inquiry/detail/${inqId.value}`) : router.push(`/pc/inquiry/list`)
    }
  })
}


const handleSubmit = async () => {
    isSubmitted.value = true;
    // 유효성 검사
    isTypeError.value = !inquiryForm.value.inqType;
    isTitleError.value = !inquiryForm.value.title.trim();
    isTextError.value = !inquiryForm.value.text.trim();
    if (inquiryForm.value.emailAlarmYn === 'Y' || inquiryForm.value.telNoAlarmYn === 'Y') {
      isAlarmError.value = false;
    } else isAlarmError.value = true;

    const errors = [];
    if (isTypeError.value) errors.push('문의 유형');
    if (isTitleError.value) errors.push('문의 제목');
    if (isTextError.value) errors.push('문의 내용');
    if (isAlarmError.value) errors.push('알림 받기');

    if (errors.length > 0) {
      showAlert({
        title: isEdit.value ? '문의 수정 실패' : '문의 등록 실패',
        message: `다음 항목을 입력해주세요.<br/>- ${errors.join('<br/>- ')}`,
        confirmText: '확인'
      });
      return;
    }
  
    try {
      const result = await fetchBuilder
        [isEdit.value ? 'put' : 'post']<Inquiry>(
        isEdit.value ? `/api/v1/inquiry/detail/${inqId.value}`: '/api/v1/inquiry')
        .body({
          hcInqTypCd: inquiryForm.value.inqType,
          inqTitle: inquiryForm.value.title,
          inqCnt: inquiryForm.value.text,
          inqEmlAdr: inquiryForm.value.email,
          inqMblTelno: inquiryForm.value.telNo,
          inqAnswEmlRcvYn: inquiryForm.value.emailAlarmYn,
          inqAnswTkRcvYn: inquiryForm.value.telNoAlarmYn,
          orderNo: inquiryForm.value.buyOrderNum,
          pointApvNo: inquiryForm.value.hmoneyTransNum,
          attachFiles: uploadFiles.value
        })
        .progressMessage("잠시만 기다려주세요...")
        .build()
        .execute()
        .then((result: any) => {
          if (result.resultCode == '200') {
            showAlert({
              title: isEdit.value ? '문의 수정 완료' : '문의 등록 완료',
              message: isEdit.value ? '문의하신 내용이 수정되었습니다.<br />빠른 시일 내 정성껏 답변 드리겠습니다.' : '문의하신 내용이 등록되었습니다.<br />빠른 시일 내 정성껏 답변 드리겠습니다.',
              confirmText: '확인',
              onConfirm: () => {
                inqId.value ? router.push(`/pc/inquiry/detail/${inqId.value}`) : router.push(`/pc/inquiry/list`)
              }
            });
            return;
          } else {
            showAlert({
              title:  isEdit.value ? '문의 수정 실패' : '문의 등록 실패',
              message: result.resultMessage || (isEdit.value ? '문의 수정에 실패했습니다.' : '문의 등록에 실패했습니다.'),
              confirmText: '확인'
            })
            return;
          }
      });
    }
    catch (error) {
      console.error('문의 등록/수정 오류:', error);
      showAlert({
        title: '오류',
        message:  isEdit.value ? '문의 수정 중 오류가 발생했습니다.' : '문의 등록 중 오류가 발생했습니다.',
        confirmText: '확인'
      });
    }
  }

// 회원정보 불러오기
const getInqUser = async () => {
  fetchBuilder
    .get(`/api/v1/inquiry/user`)
    .progressMessage("잠시만 기다려주세요...")
    .build()
    .execute()
    .then((result: any) => {
      if(result.resultCode != '200') {
        console.error(result.resultMessage);
      } else {
        // ref 형식 변수에 값 즉시 세팅
        inquiryForm.value.email = result.data.inqEmlAdr || '';
        inquiryForm.value.telNo = result.data.inqMblTelno || '';
      }
  });
}

const handleEmailAlarmYn = (isChecked: boolean) => {
  inquiryForm.value.emailAlarmYn = isChecked ? 'Y' : 'N';
}

const handleTelNoAlarm = (isChecked: boolean) => {
  inquiryForm.value.telNoAlarmYn = isChecked ? 'Y' : 'N';
}


// 값 입력시 검증문구 비노출
// watch(
//   () => inquiryForm.value,
//   (form) => {
//     if (!isSubmitted.value) return; // submit 전엔 에러 표시x

//     isTypeError.value = !form.inqType;
//     isTitleError.value = !form.title.trim();
//     isTextError.value = !form.text.trim();
//     if (form.emailAlarmYn === 'Y' || form.telNoAlarmYn === 'Y') {
//       isAlarmError.value = false;
//     } else isAlarmError.value = true;
//   },
//   { deep: true }
// )

onMounted(async () => {
  if (useHconAuthInfo().getIfPossible()) {
    // 수정모드면 데이터 fetch해서 폼에 세팅
    if (isEdit.value && route.query.id) {
      const result: any = await fetchBuilder
      .get(`/api/v1/inquiry/detail/${inqId.value}`)
      .progressMessage("잠시만 기다려주세요...")
      .build()
      .execute()
      .then((result: any) => {
        if(result.resultCode != '200') {
          showAlert(result.resultMessage);
        } else {
          inquiryForm.value = {
            inqType: inqTypeOptionList.find(opt => opt.value === result.data.hcInqTypCd)?.key ?? '',
            title: result.data.inqTitle,
            text: result.data.inqCnt,
            email: result.data.inqEmlAdr,
            telNo: result.data.inqMblTelno,
            emailAlarmYn: result.data.inqAnswEmlRcvYn,
            telNoAlarmYn: result.data.inqAnswTkRcvYn,
            buyOrderNum: result.data.orderNo,
            hmoneyTransNum: result.data.pointApvNo
          }
          uploadFiles.value = result.data.attachFileList;
        }
      });
    } else {
      // 사용자 이메일, 휴대폰번호 조회
      getInqUser();
    }
  }
})

// 구매/거래내역 팝업
const goToOrderHistoryPopup = () => {
  isOrderHistoryPopupOpen.value = true
}

const onSelectOrder = (orderNum: string) => {
  inquiryForm.value.buyOrderNum = orderNum
  isOrderHistoryPopupOpen.value = false
}

const goToHcashHistoryPopup = () => {
  isHcashHistoryPopupOpen.value = true
}

const onSelectHcash = (hcashNum: string) => {
  inquiryForm.value.hmoneyTransNum = hcashNum
  isHcashHistoryPopupOpen.value = false
}

</script>
<style lang="scss" scoped>
@use "@/assets/scss/pc/cs-hcon.scss" as *;
</style>